export default function customAreaPointToJson(customAreaPoint) {
    return {
        'latitude': customAreaPoint.latitude,
        'longitude': customAreaPoint.longitude,
        'position': customAreaPoint.position
    }
}